// extracted by mini-css-extract-plugin
module.exports = {"item":"TabBtn_item__2hPMc","btnTab":"TabBtn_btnTab__13Tz8","active":"TabBtn_active__OZcJt"};